const updateFormStyleKey = (formStyle, key, value) => Object.assign({}, formStyle, {
  [key]: value
});
export default updateFormStyleKey;